import { cn } from "@workspace/frontend-ui";

const LazyImg: FC<ImgProps> = ({
  id,
  className,
  width,
  height,
  src,
  onLoad,
  onClick,
  alt = "",
  dataAction,
  lazy = true,
  style,
}) => (
  <img
    id={id}
    alt={alt}
    className={cn(className)}
    src={src}
    width={width}
    height={height}
    onClick={onClick}
    onLoad={onLoad}
    data-action={dataAction}
    loading={lazy ? "lazy" : "eager"}
    style={style}
  />
);

export default LazyImg;
